import { render, staticRenderFns } from "./VariantMatchAssigner.vue?vue&type=template&id=8e91bb70&scoped=true"
import script from "./VariantMatchAssigner.vue?vue&type=script&lang=ts&setup=true"
export * from "./VariantMatchAssigner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./VariantMatchAssigner.vue?vue&type=style&index=0&id=8e91bb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e91bb70",
  null
  
)

export default component.exports